"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _utils = require("./utils");

function _default(Component) {
  var ShareButtonComponent = (0, _memoWithDisplayName.default)("ShareButton(" + (0, _getComponentName.default)(Component) + ")", function (props) {
    var buttonRef = props.buttonRef,
        rest = (0, _objectWithoutProperties2.default)(props, ["buttonRef"]);
    var defaultRef = (0, _react.useRef)(null);
    return _react.default.createElement(Component, (0, _extends2.default)({}, rest, {
      buttonRef: buttonRef || defaultRef
    }));
  });
  ShareButtonComponent.propTypes = (0, _extends2.default)({}, Component.propTypes, {
    buttonRef: _refObject.default
  });
  ShareButtonComponent.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareButtonComponent, Component);
  return ShareButtonComponent;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/decorators/ShareButton.js
// module id = 203
// module chunks = 0